export default __webpack_public_path__ + "static/media/learose2-768w.5c92b6b4.png";